// extracted by mini-css-extract-plugin
export default {"parentContainer":"Snackbar_parentContainer__osvld","customSnackbar":"Snackbar_customSnackbar__V55kA"};